import { skipToken } from '@tanstack/react-query';

import { AkaThemaId, ThemaFromThemaRouter } from '../dtos.ts';
import { trpc } from '../trpc';

type Result = {
  thema?: ThemaFromThemaRouter;
  linkedThema?: ThemaFromThemaRouter;
  themaQueryLoading?: boolean;
  themaQueryError?: { data: { code?: string } | null | undefined };
};

export function useThemaAndLinkedThemaQuery(akaThemaId: AkaThemaId | undefined): Result {
  const themaQuery = trpc.thema.getThemaByAkaThemaId.useQuery(akaThemaId ?? skipToken);
  const thema = themaQuery.data?.thema;
  const linkedThemaAkaProduktId =
    themaQuery.error && themaQuery.error.data?.code !== 'NOT_FOUND'
      ? undefined
      : thema?.verknuepfungBlopUndPraesenzseminar;

  const linkedThemaQuery = trpc.thema.getThemaByAkaProduktId.useQuery(linkedThemaAkaProduktId ?? skipToken);

  if (themaQuery.error && themaQuery.error.data?.code !== 'NOT_FOUND') {
    return { themaQueryError: themaQuery.error };
  }

  const linkedThema = linkedThemaQuery.data?.thema;

  if (themaQuery.isLoading || linkedThemaQuery.isLoading) {
    return { themaQueryLoading: true };
  }

  return { thema, linkedThema };
}
